import React, { useEffect } from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import makeStyles from '@mui/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from 'store/actions';

import SideAccordion from './SidebarTables';
import SideFilters from './SIdeFilters';

const useStyles = makeStyles((theme) => ({
  list: {
    height: '100%',
    width: 'auto',
    [theme.breakpoints.up('md')]: {
      width: '1100px'
    },
    overflowY: 'auto'
  },
  fullList: {
    width: 'auto'
  }
}));

const SideBar = () => {
  const classes = useStyles();
  const { open, loaded } = useSelector((state) => state.alerts);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loaded) {
      dispatch(actions.getAlertsList([], []));
    }
  }, []);

  const list = () => (
    <div
      className={classes.list}
      role="presentation"
      onKeyDown={() => dispatch(actions.toggleAlertMenu())}
    >
      <Box>
        <Box bgcolor="#ffffff">
          <List>
            <ListItem style={{ justifyContent: 'center' }}>
              <SideFilters />
            </ListItem>
          </List>
        </Box>

        <Divider />
        <Box>
          <SideAccordion />
        </Box>
        <List />
      </Box>
    </div>
  );

  return (
    <>
      <Drawer open={open} onClose={() => dispatch(actions.toggleAlertMenu())} anchor="right">
        {list()}
      </Drawer>
    </>
  );
};
export default SideBar;
